import { render } from "./daili.vue?vue&type=template&id=0dc40ab3"
import script from "./daili.vue?vue&type=script&lang=js"
export * from "./daili.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__